import {Component} from '@angular/core';

import {FormControl, FormGroup} from '@angular/forms';
import {ViewManagerService} from "../../services/view-manager.service";

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent {
  submitted = false;

  form = new FormGroup({
    firstName: new FormControl(),
    lastName: new FormControl()
  });

  constructor(private viewManager: ViewManagerService) {
  }
}
